var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./form-item.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler?id=data-v-9b52ce02!../../../../vue-loader/lib/selector?type=template&index=0!./form-item.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/packages/form/src/form-item.vue
// module id = 50
// module chunks = 2